document.addEventListener('DOMContentLoaded', () => {
	const postItems = document.querySelectorAll('.wp-block-post');
  if ( postItems.length !== 0 ) {
    postItems.forEach((postItem) => {
      let updatedTime = null;
      updatedTime = postItem.querySelector('.wp-block-post-modified-time time')?.getAttribute('datetime');
      if ( !updatedTime ) {
        updatedTime = postItem.querySelector('.wp-block-post-date time')?.getAttribute('datetime');
      }
      if ( updatedTime ) {
        const date = new Date(updatedTime);
        const now = new Date();
        const diffTime = now.getTime() - date.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        if ( diffDays <= 7 ) {
          const label = document.createElement('span');
          label.classList.add('post-new-label');
          label.textContent = 'NEW';
          postItem.appendChild(label);
        }
      }
    });
  }
});